import React, { useEffect } from "react";
import { Table  } from 'antd';
import Card from "components/card";
import CrudOption from "components/dropdown/crudoption";
import { connect } from "react-redux";
import { handleTableChange } from "utils/index";
import { 
	getPayslipList
} from "../../../../../redux/payrun/payrunState";


const PayslipTable = ({
	recordList, 
	pagination, 
	doSearch, 
	filters, 
}) => {

  	const columns = [
		{
	        title: `Payroll Cut-off`,
	        dataIndex: 'payroll',
	        key: 'payroll',
	        width: '58%',
	        render:(payroll, record) => <a href={`/private/view-payslip/${record?.ppr_employee_code}/${record?.ppr_payroll_id}/${btoa(record?.ppr_hash)}/${btoa(record?.ppr_pin)}`} target="_blank" rel="noreferrer">{`${payroll.pay_date_from} - ${payroll.pay_date_to}`}</a>
	    },
    ];
    
	useEffect(() => {
		doSearch({paginate: pagination.per_page});
	}, [doSearch, pagination.per_page]);
	
  	return (
	    <Card extra={"w-full h-full p-4"}>
	      	<div className="h-full overflow-x-scroll xl:overflow-x-hidden">
	      		<Table
		        	dataSource={recordList} 
		        	columns={columns} 
		            rowKey={(record) => record.hol_id}
		        	pagination={{...pagination, showTotal: (total, range) => `${range[0]} - ${range[1]} of ${total} records`,}}    
					onChange={handleTableChange(doSearch, filters)}                	
	        	/>
	      	</div>
	    </Card>
  );
};

const mapStateToProps = (state) => ({
	recordList: state.payrun.payslipList?.items,
	pagination: state.payrun.payslipList?.pagination,
	filters: state.payrun.payslipList?.filters,
	requesting: state.payrun.payslipList?.requesting,
	error: state.payrun.payslipList?.error,
});

const mapDispatchToProps = (dispatch) => ({
	doSearch: (filters) => dispatch(getPayslipList(filters)),
});

export default connect(mapStateToProps, mapDispatchToProps)(PayslipTable);
